<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Checkout</h3>
      </div>
      <div class="content-header-right col-md-8 col-12">
        <div class="breadcrumbs-top">
          <div class="breadcrumb-wrapper mr-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/merchant">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/merchant/checkout">Checkout</router-link></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content products">
              <div class="card-body">
                <div class="media d-flex">
                  <div class="align-self-top">
                    <i class="icon-wallet icon-opacity font-large-4 float-left"></i>
                  </div>
                  <div class="media-body text-right align-self-bottom">
                    <span class="d-block mb-1 font-medium-1">Wallet Balance</span>
                    <h1 class="mb-0">R{{balance}}</h1><br />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-accordion">
            <div class="card collapse-icon accordion-icon-rotate">
              <div class="card" v-for="order in orders" v-bind:key="order.id">
                <div class="card-header">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" data-toggle="collapse" v-bind:data-target="'#collapse-' + order.id" aria-expanded="false">
                      {{order.period_name}}
                    </button>
                  </h5>
                </div>

                <div v-bind:id="'collapse-' + order.id" class="collapse">
                  <div class="card-body">

                    <table class="table table-striped merchant-redeem-table">
                      <tbody>
                        <tr v-for="item in order.items" v-bind:key="item.id">
                          <td >{{item.label}} <br />
                            <div v-if="item.additions">
                              <small v-for="addition in item.additions" v-bind:key="addition.id">{{addition.label}} - R{{addition.price}}, </small>
                              <small v-for="exclusion in item.exclusions" v-bind:key="exclusion.id">{{exclusion.label}} - R{{exclusion.price}}, </small>
                            </div>
                          </td>
                          <td class="text-center">R{{item.price}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <fieldset class="form-group">
                      <label for="notes">Order/Delivery Notes</label>
                      <textarea class="form-control notes" rows="3"></textarea>
                    </fieldset>

                    <button type="button" class="btn btn-danger btn-block" v-on:click="placeOrder(order)">Redeem Order</button>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<style scoped>
  .merchant-redeem-table td {
    padding:0.75rem;
  }
</style>

<script>
import swal from 'sweetalert'

export default {
  name: 'checkout',
  data: function () {
    return {
      balance: '',
      orders: []
    }
  },
  mounted: function () {
    this.getOrders()
  },
  methods: {
    getOrders: function () {
      var code = window.localStorage.getItem('code')
      var that = this

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'canteenapp_parents/scan?device_identifier=' + code,
        type: 'GET',
        success: function (data) {
          that.balance = data.data.balance
          that.orders = data.data.orders
        },
        error: function (data) {
          console.log('ERROR DATA')
          console.log(data)
          swal('Error', 'Order could not be found!', 'error')
          that.$router.push('/merchant')
        }
      })
    },
    placeOrder: function (order) {
      var that = this

      // Reset the inclusions and exclusions because we might have added or removed something from the array
      var data = {
        order_id: order.id,
        notes: $('#collapse-' + order.id + ' .notes').val()
      }

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'canteenapp_orders/redeem',
        type: 'POST',
        data: data,
        success: function (data) {
          swal('Success', 'Order has been placed!', 'success')
          that.$router.push('/merchant')
        },
        error: function (data) {
          console.log('ERROR DATA')
          console.log(data)
          swal('Error', 'Order could not be placed!', 'error')
        }
      })
    }
  }
}
</script>

<style scoped>
.cart table {
  border:none;
  width:100%;
}
.cart td {
  padding:5px;
  vertical-align:middle;
}
</style>
